import { signoutUrl } from '../../api/auth';

/** Shown when Entra sign-in succeeded but the user has no Assistant App Role assignment. */
export function AccessDeniedPage() {
  return (
    <div style={{ padding: '2rem', maxWidth: 560, overflow: 'auto' }}>
      <h2>Access denied</h2>
      <p>
        Your account signed in, but it is not assigned an <strong>Assistant</strong> role on the
        JARVIS IT Assistant enterprise application. Ask an administrator to grant one of{' '}
        <strong>AssistantUser</strong>, <strong>AssistantDevOps</strong>,{' '}
        <strong>AssistantAdmin</strong>, or <strong>AssistantSysAdmin</strong> in Entra ID.
      </p>
      <button
        type="button"
        onClick={() => {
          window.location.assign(signoutUrl());
        }}
        style={{
          marginTop: '1rem',
          padding: '0.5rem 1rem',
          border: 'none',
          borderRadius: 6,
          background: 'var(--danger, #c62828)',
          color: '#fff',
          cursor: 'pointer',
          fontWeight: 600
        }}
      >
        Sign out
      </button>
    </div>
  );
}
